export const CROSSVERSION_OVERVIEW_MODEL_NAME = "Prozess_WF_O";
export const CROSSVERSION_DOC_MODEL_NAME = "Prozess_WF";
export const FV_MAIN_MODULE_NAME = "Module";

export const APPMODEL_PROCESS_ID_ANNOTATION = "processId";
export const APPMODEL_INITIAL_TASK_FORM_ANNOTATION = "initialTaskForm";
